// Imports
import React from 'react';
import Link from '@material-ui/core/Link';
import Dialog from '@material-ui/core/Dialog';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardMedia from '@material-ui/core/CardMedia';
import CardContent from '@material-ui/core/CardContent';
import CardActions from '@material-ui/core/CardActions';
import CodeIcon from '@material-ui/icons/Code';
import GitHubIcon from '@material-ui/icons/GitHub';
import LinkIcon from '@material-ui/icons/Link';
import { makeStyles } from '@material-ui/core/styles';
import grey from '@material-ui/core/colors/grey';
import Grid from '@material-ui/core/Grid';

// Components
import ProjectCard from './project-card';

// CSS
import './../styles/css/project-card-popup.css';

// Material UI
const useStyles = makeStyles((theme) => ({
    root: {
        minWidth: 300,
        maxWidth: 400,
        overflow: 'auto',
    },
    header: {
        height: 10,
        textAlign: 'center',
    },
}));

export default function ProjectCardPopup({ name, preview, image, desc, tech, github, link }) {
    const classes = useStyles();

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    const parseDesc = desc.map((line) =>
        <div key={line.id}>
            {line}
            <br /><br />
        </div>,
    );

    const ifGithubLink = () => {
        if (github && link) {
            return (
                <CardActions>
                    <a href={github} className="link-icon" rel="noopener noreferrer" target="_blank">
                        <GitHubIcon style={{ color: grey[900] }} />
                    </a>
                    <a href={link} rel="noopener noreferrer" target="_blank">
                        <LinkIcon style={{ color: grey[900] }} />
                    </a>
                </CardActions>
            );
        } else if (github) {
            return (
                <CardActions>
                    <a href={github} className="link-icon" rel="noopener noreferrer" target="_blank">
                        <GitHubIcon style={{ color: grey[900] }} />
                    </a>
                </CardActions>
            );
        } else if (link) {
            return (
                <CardActions>
                    <a href={link} className="link-icon" rel="noopener noreferrer" target="_blank">
                        <LinkIcon style={{ color: grey[900] }} />
                    </a>
                </CardActions>
            );
        } else {
            return (null);
        }
    };

    return (
        <div>
            <Grid
                container
                spacing={0}
                direction="column"
                alignItems="center"
                justify="center"
            >
                <Link underline="no" onClick={handleClickOpen}>
                    <ProjectCard name={name} image={preview} />
                </Link>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description">
                    <Card className={classes.root} variant="outlined">
                        <CardHeader className={classes.header} title={name} />
                        <CardMedia component="img" src={image} />
                        <CardContent>
                            <div className="tech-stack">
                                <CodeIcon style={{ color: grey[900] }} /> {tech}
                            </div>
                            <br />
                            <div>
                                {parseDesc}
                            </div>
                        </CardContent>
                        <div className="links">
                            {ifGithubLink()}
                        </div>
                    </Card>
                </Dialog>
            </Grid>
        </div>
    );
}
